import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-363f773a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Logout")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Seleziona la classe")
const _hoisted_3 = {
  key: 0,
  id: "container"
}

import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonLabel,
  IonItem,
  IonList,
  IonButton,
  IonButtons,
} from '@ionic/vue';
import UserService from "@/api/users/UserService";
import { useRouter } from "vue-router";
import {computed} from "vue";
// import './selectclass.scss'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const {
  getUserClasses,
    fetchUserClasses
} = UserService()

fetchUserClasses()

const classes = computed(() => getUserClasses())

// if (!getUserClasses().classes) {
// console.log('fetchClasses')
//   fetchUserClasses()
// }

const classSelected = classe => {
  localStorage.removeItem('currentClass')
  localStorage.setItem('currentClass', JSON.stringify(classe))
  router.replace({path: 'home'})
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "primary" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), { "router-link": "/logout" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { class: "label" }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        class: "ion-padding bg-light"
      }, {
        default: _withCtx(() => [
          (_unref(classes).classes)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(IonList), {
                  lines: "none",
                  class: "ion-no-margin"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(classes).classes, (classe) => {
                      return (_openBlock(), _createBlock(_unref(IonItem), {
                        key: classe.id,
                        onClick: ($event: any) => (classSelected(classe))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(classe.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})